import { createTheme } from '@material-ui/core';

export const colors = {
  orange: '#e37f00',
  light: '#9b9fb4',
  gray: '#242934',
  pale: 'rgba(148,179,234,0.1)',
  darkgray: '#404350',
  // purple: '#9b9fb4',
  purple: '#20B2AA',
  // purple: '#7f63fa',
  white: '#ffffff',
  red: '#e30000',
  dark: '#171a1f',
};

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: colors.purple }, // #66fcf1
    secondary: { main: colors.light },
    common: {
      white: colors.white,
      pale: colors.pale,
      gray: '#979595',
      darkgray: colors.darkgray,
    },
    background: { main: colors.orange },
    action: { main: colors.orange },
    grey: { main: colors.orange, comtrastText: 'white' },
    info: { main: colors.gray },
    success: { main: colors.purple },
    warning: { main: colors.orange },
    error: { main: colors.red },
    text: { main: colors.white },
  },
  overrides: {
    MuiIconButton: {
      root: {
        color: colors.white,
      },
    },
    MuiAppBar: {
      root: {
        borderColor: colors.purple,
        backgroundColor: colors.pale,
      },
    },
    MuiFormControl: {
      root: {
        '& .MuiFormLabel-root.MuiInputLabel-animated.Mui-disabled': {
          color: colors.darkgray,
        },
      },
    },
    MuiFormLabel: {
      root: {
        '&.Mui-disabled': {
          color: colors.light,
          borderColor: colors.light,
        },
      },
    },
    MuiPaper: {
      root: {
        '&.MuiMenu-paper': {
          backgroundColor: colors.dark,
        },
        '&.MuiPaper-elevation': {
          backgroundColor: colors.dark,
          color: colors.light,
          '& svg': {
            fill: colors.light,
          },
        },
        '&::-webkit-scrollbar': {
          width: 10,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: colors.purple,
          borderRadius: 3,
        },

        '& .MuiDateCalendar-root': {
          '& span': {
            color: colors.light,
          },
          '& button.MuiPickersDay-root': {
            color: colors.light,
            backgroundColor: colors.pale,
          },
          '& button.Mui-selected': {
            backgroundColor: colors.purple,
            color: colors.white,
          },
          '& .MuiYearCalendar-root': {
            '&::-webkit-scrollbar': {
              width: 10,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: colors.purple,
              borderRadius: 3,
            },
          },
        },
      },
    },
    MuiInputBase: {
      root: {
        '& input:-webkit-autofill': {
          'box-shadow': `0 0 0px 1000px ${colors.gray} inset`,
          '-webkit-text-fill-color': colors.white,
        },
        '&.MuiInputBase-root': {
          color: colors.white,

          '&:hover': {
            borderColor: colors.purple,
          },
        },
        '&.MuiInputBase-root:hover': {
          borderColor: colors.purple,
        },
        '&.MuiInput-underline:before': {
          borderBottomColor: colors.light,
        },
        '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
          borderBottomColor: colors.light,
        },
        '&.MuiInput-underline.Mui-disabled:before': {
          borderBottomStyle: 'solid',
          borderBottomColor: colors.orange,
        },
        '&.Mui-disabled': {
          color: colors.purple,
          '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: colors.light,
          },
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.light,
        },
        '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.purple,
        },

        '& .MuiSvgIcon-root ': {
          fill: colors.light,
        },
        '& .MuiButtonBase-root .MuiSvgIcon-root:hover': {
          fill: colors.purple,
        },
      },
    },
  },
  typography: palette => ({
    allVariants: {
      color: palette.secondary.main,
    },
  }),
});
